import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'black';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    light: 'bg-brand-red-light',
    black: 'bg-brand-black text-white'
  };
  return <section id={id} className={`py-20 md:py-32 ${bgColors[background]} ${className}`} data-id="element-368">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-369">
        {children}
      </motion.div>
    </section>;
}